import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';

import Navbar from './components/Navbar';

import Home from './pages/Home';
import Rooms from './pages/Rooms';
import Booking from './pages/Booking';
import Confirmation from './pages/Confirmation';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminBookings from './pages/admin/AdminBookings';
import AdminRooms from './pages/admin/AdminRooms';
import AdminPayments from './pages/admin/AdminPayments';
import AdminReports from './pages/admin/AdminReports';
import { Toaster } from './components/ui/sonner';
import AboutForest from './pages/AboutForest';
import Safari from './pages/Safari';
import AboutUs from './pages/AboutUs';

function App() {
  return (
    <BrowserRouter>
      <Navbar />

      {/* Page wrapper to offset fixed navbar */}
      <div className="pt-20">
        <Routes>
          {/* Public */}
          <Route path="/" element={<Home />} />
          <Route path="/rooms" element={<Rooms />} />
          <Route path="/booking/:roomId" element={<Booking />} />
          <Route path="/confirmation/:bookingId" element={<Confirmation />} />
          <Route path="/forest" element={<AboutForest />} />
          <Route path="/safari" element={<Safari />} />
          <Route path="/about" element={<AboutUs />} />

          {/* Admin (hidden entry via /manage) */}
          <Route path="/manage/login" element={<AdminLogin />} />
          <Route path="/manage/dashboard" element={<AdminDashboard />} />
          <Route path="/manage/bookings" element={<AdminBookings />} />
          <Route path="/manage/rooms" element={<AdminRooms />} />
          <Route path="/manage/payments" element={<AdminPayments />} />
          <Route path="/manage/reports" element={<AdminReports />} />

          {/* Legacy admin routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/bookings" element={<AdminBookings />} />
          <Route path="/admin/rooms" element={<AdminRooms />} />
          <Route path="/admin/payments" element={<AdminPayments />} />
          <Route path="/admin/reports" element={<AdminReports />} />
        </Routes>
      </div>

      <Toaster position="top-center" />
    </BrowserRouter>
  );
}

export default App;
